import { useTranslation } from 'react-i18next';
import React, { useContext, useState, useEffect } from "react"
import ListComponent from "@/components/listComponent"
import TopSearch from "@/components/TopSearch"
import { getMaintenanceList, disableMaintenance, getPartStatistical } from "@/service/maintenanceService"
import { MyContext } from "@/store/myContext"
import { download, convertRes2Blob } from "@/utils/exportExcel"
import Loading from "@/components/Loading"
import { getPcodeDict } from "@/utils/dataStorage"
import { ItemAttr } from "@/utils/enum"
import { Select } from "antd"

//维修配件
const MaterialManage = () => {
    const { t } = useTranslation();
    const [exportLoading, setExportLoading] = useState(false) //导出loading
    const { dispatch, state, message, detailsPage, Switch } = useContext(MyContext)
    const [materialList, setMaterialList] = useState([]) //列表
    const [selectInfo, setSelectInfo] = useState({ rowInfo: {}, rowIndex: -1 }) //记录当前行下标
    const [subTitle, setSubTitle] = useState([])
    const [pagination, setpagination] = useState({
        //分页配置
        total: 0,
        current: 1,
        pageSize: 10,
    })
    const [searchValue, setSearchValue] = useState({}) //搜索
    const [partOrigins, setPartOrigins] = useState(null) //产地 字典

    useEffect(() => {
        if (state.activeMenu === "materialManage") {
            loadData(pagination.current)
            // console.log(Switch)
            getPartStatistical()
            .then((res) => {
                let subTitle = []
                    res.retData.forEach(item => {
                        if(item.brand && item.count){
                            subTitle.push(`${item.brand}:${item.count}${t(`dataManage.materialManage.index.条`)}`)
                        }
                        if(!item.brand && item.count){
                            subTitle.push(`${t(`dataManage.materialManage.index.其他`)}:${item.count}${t(`dataManage.materialManage.index.条`)}`)
                        }
                    })
                    setSubTitle(subTitle)
            })
        }
        return () => setMaterialList([])
    }, [state.activeMenu])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        let obj = { partOrigin: {} } //工单来源
        getPcodeDict("108").children.forEach((item) => {
            obj.partOrigin[item.dictCode] = item.title
        })
        setPartOrigins(obj)
    }, [])
    //列表数据
    const loadData = (current, search = {}) => {
        let data = {
            searchItem: { ...search },
            pageNum: current,
            pageSize: 10,
            orders: [
                {
                    column: "updateTime",
                    rule: "DESC",
                },
            ],
        }
        getMaintenanceList(data).then((res) => {
            // if (res && res.retCode === 200) {
                setSelectInfo({ rowInfo: {}, rowIndex: -1 })
                setpagination({
                    current: current,
                    total: res.retData.total,
                    pageSize: 10,
                })
                setMaterialList(res.retData.list)
            // }
        })
    }
    //分页事件
    const onTableChange = async (page) => {
        await setpagination({
            ...pagination,
            current: page.current,
        })
        loadData(page.current, searchValue)
    }
    //新增
    const handleDetails = async (mode) => {
        let tabName = {
            insert: t(`dataManage.materialManage.index.配件新增`),
            edit: t(`dataManage.materialManage.index.配件编辑`),
            look: t(`dataManage.materialManage.index.配件查看`),
        }
        let modeKey = "materialManage/" + mode
        if (mode === "edit") {
            if (!Object.keys(selectInfo.rowInfo).length) {
                message.warning(t(`dataManage.materialManage.index.请选择你要编辑的配件信息`))
                return
            }
            modeKey += "/" + selectInfo.rowInfo.id
        } else if (mode === "look") {
            if (!Object.keys(selectInfo.rowInfo).length) {
                message.warning(t(`dataManage.materialManage.index.请选择你要查看的配件信息`))
                return
            }

            //每次查看把之前的删除， 重新生成
            await dispatch({
                type: "removeTabs",
                targetKey: modeKey,
            })
        }
        await dispatch({
            type: "changeTabs",
            name: tabName[mode],
            activeMenu: modeKey,
            content: detailsPage.MaterialDetails({
                modeKey,
                dispatch,
                mode,
                rowInfo: selectInfo.rowInfo,
            }),
        })
    }
    //配件开关
    const materialSweitchChange = (checked, e, id) => {
        e.stopPropagation()
        disableMaintenance({ id: id, disableFlag: checked ? 0 : 1 }).then((res) => {
            // if (res && res.retCode === 200) {
                message.success(t(`dataManage.materialManage.index.操作成功`))
            // } else {
            //     message.error(res.retMsg)
            // }
        })
    }
    //导出
    const exportProt = async () => {
        setExportLoading(true)
        let data = {
            type: "post",
            data: {
                searchItem: searchValue,
                orders: [{ column: "updateTime", rule: "DESC" }],
            },
        }
        let resFlie = await download("/ci/maintenance_part/export", data)
        if (resFlie && resFlie.status === 200) {
            message.success(t(`dataManage.materialManage.index.已导出`))
            convertRes2Blob(resFlie)
        } else {
            message.warning(t(`dataManage.materialManage.index.导出异常，请重新尝试`))
        }
        setExportLoading(false)
    }
    //table配置
    const columns = [
        {
            title: t(`dataManage.materialManage.index.商品编号`),
            align: "center",
            dataIndex: "partCode",
        },
        {
            title: t(`dataManage.materialManage.index.商品名称`),
            align: "center",
            dataIndex: "partName",
        },
        {
            title: t(`dataManage.materialManage.index.配件属性`),
            align: "center",
            dataIndex: "partAttr",
            render: (text) => <p>{ItemAttr[text]}</p>,
        },
        {
            title: t(`dataManage.materialManage.index.单位`),
            align: "center",
            dataIndex: "partUnit",
        },
        {
            title: t(`dataManage.materialManage.index.规格`),
            align: "center",
            dataIndex: "partSpec",
        },
        {
            title: t(`dataManage.materialManage.index.商品品牌`),
            align: "center",
            dataIndex: "partBrand",
        },
        {
            title: t(`dataManage.materialManage.index.适用车型`),
            align: "center",
            dataIndex: "partApplicableModel",
        },
        {
            title: t(`dataManage.materialManage.index.产地`),
            align: "center",
            dataIndex: "partOrigin",
            render: (text) => <>{partOrigins.partOrigin[text]}</>,
        },
        {
            title: t(`dataManage.materialManage.index.分组代码`),
            align: "center",
            dataIndex: "partGroupCode",
        },
        {
            title: t(`dataManage.materialManage.index.分类代码`),
            align: "center",
            dataIndex: "partClassificationCode",
        },
        {
            title: t(`dataManage.materialManage.index.进货价`),
            align: "center",
            dataIndex: "partPurchasePrice",
        },
        {
            title: t(`dataManage.materialManage.index.零售价`),
            align: "center",
            dataIndex: "partRetailPrice",
        },
        {
            title: t(`dataManage.materialManage.index.备注`),
            align: "center",
            dataIndex: "remark",
        },
        {
            title: t(`dataManage.materialManage.index.操作`),
            align: "center",
            width: "12%",
            dataIndex: "disableFlag",
            render: (text, record) => (
                <Switch size="small" defaultChecked={text === 0 ? true : false} onChange={(checked, e) => materialSweitchChange(checked, e, record.id)} />
            ),
        },
    ]
    //搜索JSON
    const searchList = {
        normalList: [
            {
                type: "select",
                placeholder: t(`dataManage.materialManage.index.请选择配件属性`),
                valueName: "partAttr",
                optionList: () =>
                Object.entries(ItemAttr).map((item) => (
                        <Select.Option value={item[0]} key={item[0]}>
                            {item[1]}
                        </Select.Option>
                    )),
            },
            {
                type: "input",
                placeholder: t(`dataManage.materialManage.index.请输入商品编号`),
                valueName: "partCode",
            },
            {
                type: "input",
                placeholder: t(`dataManage.materialManage.index.请输入商品名称`),
                valueName: "partName",
            },
            {
                type: "input",
                placeholder: t(`dataManage.materialManage.index.请输入商品品牌`),
                valueName: "partBrand",
            },
        ],
    }
    //列表button
    const topButtons = [
        {
            click: () => handleDetails("insert"),
            content: t(`dataManage.materialManage.index.新增`),
        },
        {
            click: () => handleDetails("look"),
            content: t(`dataManage.materialManage.index.查看`),
        },
        {
            click: () => handleDetails("edit"),
            content: t(`dataManage.materialManage.index.编辑`),
        },
        {
            content: t(`dataManage.materialManage.index.导入`),
            upload: true,
            actionUrl: "ci/maintenance_part/import",
            onChange(info) {
                if (info.file.status === "done" && info.file?.response?.retCode === 200) {
                    message.success({
                        content: `${info.file.name}${t(`dataManage.materialManage.index.导入`)}${info?.file?.response?.retData}`,
                        duration: 8,
                    })
                } else if (info.file.status === "error") {
                    message.error(`${info.file.name}${t(`dataManage.materialManage.index.导入异常，请尝试重新导入`)}`)
                }
            },
        },
        {
            click: () => exportProt(),
            content: t(`dataManage.materialManage.index.导出`),
        },
    ]
    return (
        <>
            {state.activeMenu === "materialManage" && (
                <>
                    <TopSearch
                        title= {t(`dataManage.materialManage.index.配件管理`)}
                        searchListData={searchList}
                        searchValue={searchValue}
                        setSearchValue={(obj) => setSearchValue(obj)}
                        handleSearch={loadData}
                    />
                    <ListComponent
                        title= {t(`dataManage.materialManage.index.配件列表`)}
                        subTitle={subTitle}
                        buttons={topButtons}
                        columns={columns}
                        dataSource={materialList}
                        pagination={pagination}
                        onTableChange={onTableChange}
                        selectInfo={selectInfo}
                        setSelectInfo={(obj) => setSelectInfo(obj)}
                    />
                     {
                        exportLoading && <Loading />
                    }
                </>
            )}
        </>
    )
}
export default MaterialManage
